import { Card, Box, Icon, Text, SimpleGrid } from "@chakra-ui/react";
import React, { useEffect, useRef, useState } from 'react';
import * as signalR from "@microsoft/signalr";
import axios from "axios";
import './Meters.css';
import './Panels.css';
import click from './sounds/shortclick.mp3';
//import { Device } from "./Device.jsx";
import { FaCircle, FaCheckCircle, FaExclamationCircle, FaSpinner } from 'react-icons/fa';
import dso from './images/DSO.jpg';
import pumpoff from './images/PumpOff.png';
import flood from './images/FloodNormal.png';
import waterlevel from './images/WaterTank.png';
import { useNavigate } from 'react-router-dom';

export default function Panels2() {
    const tindex = useRef(1);
    const [dev, setDev] = useState([]);
    const [displayDev, setDisplayDev] = useState([]);
    const [retry, setRetry] = useState(false);
    const [selectedType, setSelectedType] = useState(1);
    const [buildingId, setBuildingId] = useState(1);
    const LargeCellText = "30px";

    // Navigation
    const navigate = useNavigate();

    const playClickSound = () => {
        const audio = new Audio(click);
        audio.play();
        audio.onended = () => { }
    };

    function handleClick(e) {
        console.log("Button clicked with value:", e); // Add this line
        playClickSound();
        setBuildingId(e);

    };

    function handleVBClick(e,f) {
        navigate(`/vibration?device1=${e}&device2=${f}`);
        playClickSound();
    };

    // Create a connection to the hub
    const connection = new signalR.HubConnectionBuilder()
        .withUrl("/devicehub")
        .build();

    useEffect(() => {

        const httpClient = axios.create({
            baseURL: 'https://futipiot.ddns.net',
            headers: {
                'Content-Type': 'application/json'
            }
        });

        const getData = async () => {
            try {
                const response = await httpClient.get('/api/meters');
                const deviceDetails = response.data.map((item) => ({
                    id: item.deviceId,
                    deviceName: item.deviceName,
                    deviceEui: item.deviceEui,
                    label: item.label,
                    status: item.status,
                    type: item.type,
                    data_type: item.dataType,
                    alive: item.alive,
                    data: item.data,
                    channel: item.channel,
                    unit: item.unit
                }));

                let paneldevices = deviceDetails.filter(d => d.data_type === 13);
                console.log("PanelDev:", paneldevices);

                setDev(paneldevices); // Store all panel devices
                setDisplayDev(paneldevices);
            } catch (error) {
                console.error(error);
                setRetry(true);
            }
        };

        getData();
    }, [retry]);

    useEffect(() => {
        console.log("Updating web page...");
        const httpClient = axios.create({
            baseURL: 'https://futipiot.ddns.net',
            headers: {
                'Content-Type': 'application/json'
            }
        });

        const getData = async () => {
            try {
                const response = await httpClient.get('/api/meters');
                const deviceDetails = response.data.map((item) => ({
                    id: item.deviceId,
                    deviceName: item.deviceName,
                    deviceEui: item.deviceEui,
                    label: item.label,
                    status: item.status,
                    type: item.type,
                    data_type: item.dataType,
                    alive: item.alive,
                    data: item.data,
                    channel: item.channel,
                    unit: item.unit
                }));

                let paneldevices = deviceDetails.filter(d => d.data_type === 13);
                console.log("PanelDev:", paneldevices);

                setDev(paneldevices); // Store all panel devices
                setDisplayDev(paneldevices);
            } catch (error) {
                console.error(error);
                setRetry(true);
            }
        };
        connection
            .start()
            .then(() => console.log("Connected to the hub"))
            .catch((err) => console.error(err));

        // Register a handler for receiving device data from the hub
        connection.on("ReceiveDeviceData", () => {
            // Update the state with the new device data
            console.log("Updating....")
            getData();
        });
    }, []);

    useEffect(() => {
        console.log("DisplayDev updated:", displayDev);
    }, [displayDev]);

    function FFreshList() {
        if (!displayDev || displayDev.length === 0) {
            return <div>No devices to display</div>;
        }

        return (
            <div>
                <tr className="row">
                    <td className="pumppanelcellstyle2" style={{
                        fontSize: "24px",
                        overflow: "hidden",
                        color: "#202020",
                        backgroundColor: "#A2A2A2",
                    }}>
                        <table>
                            <td>
                            <tr style={{ height: "24px", fontWeight: "bold" }}>盈輝樓食水泵</tr>
                            <tr>
                                <td>#1號泵運行中</td>
                                <td>
                                    <FaCircle style={{ color: displayDev[0].status[0] === "1" ? "#00ff00" : "#cccccc" }} />
                                </td>
                            </tr>
                            <tr>
                                <td>#1號泵電流過低</td>
                                <td>
                                    <FaCircle style={{ color: displayDev[0].status[1] === "1" ? "red" : "#cccccc" }} />
                                </td>
                            </tr>
                            <tr>
                                <td>#1號泵電壓過低</td>
                                <td>
                                    <FaCircle style={{ color: displayDev[1].status[0] === "1" ? "red" : "#cccccc" }} />
                                </td>
                            </tr>
                            <tr>
                                <td>#1號泵超過負荷</td>
                                <td>
                                    <FaCircle style={{ color: displayDev[1].status[1] === "1" ? "red" : "#cccccc" }} />
                                </td>
                                </tr>
                            </td>
                            {/*<td>
                                <tr>
                                    <div className="vbbuttonstyle" style={{ fontSize: "24px", color: "#202020", backgroundColor: "#ffa500" , zIndex: 10, position: "relative" }} onClick={() => handleVBClick(61,62)}>
                                        #1號泵震動紀錄
                                    </div>
                                </tr>
                            </td>*/}
                        </table>
                    </td>

                    <td className="pumppanelcellstyle2" style={{
                        fontSize: "24px",
                        overflow: "hidden",
                        color: "#202020",
                        backgroundColor: "#A2A2A2",
                    }}>
                        <table>
                            <td>
                            <tr style={{ height: "24px", fontWeight: "bold" }}>盈輝樓食水泵</tr>
                            <tr>
                                <td>#2號泵運行中</td>
                                <td>
                                    <FaCircle style={{ color: displayDev[2].status[0] === "1" ? "#00ff00" : "#cccccc" }} />
                                </td>
                            </tr>
                            <tr>
                                <td>#2號泵電流過低</td>
                                <td>
                                    <FaCircle style={{ color: displayDev[2].status[1] === "1" ? "red" : "#cccccc" }} />
                                </td>
                            </tr>
                            <tr>
                                <td>#2號泵電壓過低</td>
                                <td>
                                    <FaCircle style={{ color: displayDev[3].status[0] === "1" ? "red" : "#cccccc" }} />
                                </td>
                            </tr>
                            <tr>
                                <td>#2號泵超過負荷</td>
                                <td>
                                    <FaCircle style={{ color: displayDev[3].status[1] === "1" ? "red" : "#cccccc" }} />
                                </td>
                                </tr>
                            </td>
                            {/*<td>
                                <tr>
                                    <div className="vbbuttonstyle" style={{ fontSize: "24px", color: "#202020", backgroundColor: "#ffa500", zIndex: 10, position: "relative" }} onClick={() => handleVBClick(63,64)}>
                                        #2號泵震動紀錄
                                    </div>
                                </tr>
                            </td>*/}
                        </table>
                    </td>

                    <td className="pumppanelcellstyle2" style={{
                        fontSize: "24px",
                        overflow: "hidden",
                        color: "#202020",
                        backgroundColor: "#A2A2A2",
                    }}>
                        <table>
                            <td>
                                <tr style={{ height: "24px", fontWeight: "bold" }}>盈輝樓食水夜行泵</tr>
                            <tr>
                                    <td>#3號夜行泵運行中</td>
                                <td>
                                    <FaCircle style={{ color: displayDev[4].status[0] === "1" ? "#00ff00" : "#cccccc" }} />
                                </td>
                            </tr>
                            <tr>
                                    <td>#3號夜行泵電流過低</td>
                                <td>
                                    <FaCircle style={{ color: displayDev[4].status[1] === "1" ? "red" : "#cccccc" }} />
                                </td>
                            </tr>
                            <tr>
                                    <td>#3號夜行泵電壓過低</td>
                                <td>
                                    <FaCircle style={{ color: displayDev[5].status[0] === "1" ? "red" : "#cccccc" }} />
                                </td>
                            </tr>
                            <tr>
                                    <td>#3號夜行泵超過負荷</td>
                                <td>
                                    <FaCircle style={{ color: displayDev[5].status[1] === "1" ? "red" : "#cccccc" }} />
                                </td>
                                </tr>
                            </td>
                            {/*<td>
                                <td>
                                    <tr>
                                        <div className="vbbuttonstyle" style={{ fontSize: "24px", color: "#202020", backgroundColor: "#ffa500", zIndex: 10, position: "relative" }} onClick={() => handleVBClick(65,66)}>
                                            #3號夜行泵震動紀錄
                                        </div>
                                    </tr>
                                </td>
                            </td>*/}
                        </table>
                    </td>

                    <td className="pumppanelcellstyle" style={{
                        fontSize: "24px",
                        overflow: "hidden",
                        color: "#202020",
                        backgroundColor: "#A2A2A2",
                    }}>
                        <table>
                            <tr style={{ height: "24px", fontWeight: "bold" }}>盈輝樓食水泵</tr>
                            <tr>
                                <td>食水缸低水位</td>
                                <td>
                                    <FaCircle style={{ color: displayDev[6].status[0] === "1" ? "red" : "#cccccc" }} />
                                </td>
                            </tr>
                        </table>
                    </td>
                    <td className="pumppanelcellstyle2" style={{
                        fontSize: "24px",
                        overflow: "hidden",
                        color: "#202020",
                        backgroundColor: "#A2A2A2",
                    }}>
                        <table>
                            <td>
                            <tr style={{ height: "24px", fontWeight: "bold" }}>盈輝樓咸水泵</tr>
                            <tr>
                                <td>#1號泵運行中</td>
                                <td>
                                    <FaCircle style={{ color: displayDev[7].status[0] === "1" ? "#00ff00" : "#cccccc" }} />
                                </td>
                            </tr>
                            <tr>
                                <td>#1號泵電流過低</td>
                                <td>
                                    <FaCircle style={{ color: displayDev[7].status[1] === "1" ? "red" : "#cccccc" }} />
                                </td>
                            </tr>
                            <tr>
                                <td>#1號泵電壓過低</td>
                                <td>
                                    <FaCircle style={{ color: displayDev[8].status[0] === "1" ? "red" : "#cccccc" }} />
                                </td>
                            </tr>
                            <tr>
                                <td>#1號泵超過負荷</td>
                                <td>
                                    <FaCircle style={{ color: displayDev[8].status[1] === "1" ? "red" : "#cccccc" }} />
                                </td>
                                </tr>
                            </td>
                            {/*<td>
                                <td>
                                    <tr>
                                        <div className="vbbuttonstyle" style={{ fontSize: "24px", color: "#202020", backgroundColor: "#ffa500", zIndex: 10, position: "relative" }} onClick={() => handleVBClick(57,58)}>
                                            #1號泵震動紀錄
                                        </div>
                                    </tr>
                                </td>
                            </td>*/}
                        </table>
                    </td>

                    <td className="pumppanelcellstyle2" style={{
                        fontSize: "24px",
                        overflow: "hidden",
                        color: "#202020",
                        backgroundColor: "#A2A2A2",
                    }}>
                        <table>
                        <td>
                            <tr style={{ height: "24px", fontWeight: "bold" }}>盈輝樓咸水泵</tr>
                            <tr>
                                <td>#2號泵運行中</td>
                                <td>
                                    <FaCircle style={{ color: displayDev[9].status[0] === "1" ? "#00ff00" : "#cccccc" }} />
                                </td>
                            </tr>
                            <tr>
                                <td>#2號泵電流過低</td>
                                <td>
                                    <FaCircle style={{ color: displayDev[9].status[1] === "1" ? "red" : "#cccccc" }} />
                                </td>
                            </tr>
                            <tr>
                                <td>#2號泵電壓過低</td>
                                <td>
                                    <FaCircle style={{ color: displayDev[10].status[0] === "1" ? "red" : "#cccccc" }} />
                                </td>
                            </tr>
                            <tr>
                                <td>#2號泵超過負荷</td>
                                <td>
                                    <FaCircle style={{ color: displayDev[10].status[1] === "1" ? "red" : "#cccccc" }} />
                                </td>
                                </tr>
                            </td>
                            {/*<td>
                                <td>
                                    <tr>
                                        <div className="vbbuttonstyle" style={{ fontSize: "24px", color: "#202020", backgroundColor: "#ffa500", zIndex: 10, position: "relative" }} onClick={() => handleVBClick(59,60)}>
                                            #2號泵震動紀錄
                                        </div>
                                    </tr>
                                </td>
                            </td>*/}
                        </table>
                    </td>

                    <td className="pumppanelcellstyle2" style={{
                        fontSize: "24px",
                        overflow: "hidden",
                        color: "#202020",
                        backgroundColor: "#A2A2A2",
                    }}>
                        <table>
                            <tr style={{ height: "24px", fontWeight: "bold" }}>盈輝樓咸水泵</tr>
                            <tr>
                                <td>咸水缸低水位</td>
                                <td>
                                    <FaCircle style={{ color: displayDev[11].status[0] === "1" ? "red" : "#cccccc" }} />
                                </td>
                            </tr>
                        </table>
                    </td>

                </tr>
            </div>
        );
    }

    function FMiddleAndFireList() {
        if (!displayDev || displayDev.length === 0) {
            return <div>No devices to display</div>;
        }

        return (
            <div>
                <tr className="row">
                    <td className="pumppanelcellstyle3" style={{
                        fontSize: "24px",
                        overflow: "hidden",
                        color: "#202020",
                        backgroundColor: "#A2A2A2",
                    }}>
                        <table>
                            <td>
                                <tr style={{ height: "24px", fontWeight: "bold" }}>盈輝樓天台食水加壓泵</tr>
                                <tr>
                                    <td>#1號泵運行中</td>
                                    <td>
                                        <FaCircle style={{ color: displayDev[32].status[0] === "1" ? "#00ff00" : "#cccccc" }} />
                                    </td>
                                </tr>
                                <tr>
                                    <td>#1號泵電壓過低</td>
                                    <td>
                                        <FaCircle style={{ color: displayDev[32].status[1] === "1" ? "red" : "#cccccc" }} />
                                    </td>
                                    </tr>
                            </td>
                            <td>
                                <td>
                                    <tr>
                                        <div className="vbbuttonstyle" style={{ fontSize: "24px", color: "#202020", backgroundColor: "#ffa500", zIndex: 10, position: "relative" }} onClick={() => handleVBClick(77,78)}>
                                            #1號泵震動紀錄
                                        </div>
                                    </tr>
                                </td>
                            </td>
                        </table>
                    </td>

                    <td className="pumppanelcellstyle3" style={{
                        fontSize: "24px",
                        overflow: "hidden",
                        color: "#202020",
                        backgroundColor: "#A2A2A2",
                    }}>
                        <table>
                            <td>
                                <tr style={{ height: "24px", fontWeight: "bold" }}>盈輝樓天台食水加壓泵</tr>
                                <tr>
                                    <td>#2號泵運行中</td>
                                    <td>
                                        <FaCircle style={{ color: displayDev[33].status[0] === "1" ? "#00ff00" : "#cccccc" }} />
                                    </td>
                                </tr>
                                <tr>
                                    <td>#2號泵電壓過低</td>
                                    <td>
                                        <FaCircle style={{ color: displayDev[33].status[1] === "1" ? "red" : "#cccccc" }} />
                                    </td>
                                </tr>
                            </td>
                            <td>
                                <td>
                                    <tr>
                                        <div className="vbbuttonstyle" style={{ fontSize: "24px", color: "#202020", backgroundColor: "#ffa500", zIndex: 10, position: "relative" }} onClick={() => handleVBClick(79,80)}>
                                            #2號泵震動紀錄
                                        </div>
                                    </tr>
                                </td>
                            </td>
                        </table>
                    </td>

                    <td className="pumppanelcellstyle3" style={{
                        fontSize: "20px",
                        overflow: "hidden",
                        color: "#202020",
                        backgroundColor: "#A2A2A2",
                    }}>
                        <table>
                        <td>
                                <tr style={{ height: "24px", fontWeight: "bold" }}>盈輝樓天台食水加壓泵</tr>
                            <tr>
                                <td>#3號泵運行中</td>
                                <td>
                                    <FaCircle style={{ color: displayDev[34].status[0] === "1" ? "#00ff00" : "#cccccc" }} />
                                </td>
                            </tr>
                            <tr>
                                <td>#3號泵電壓過低</td>
                                <td>
                                    <FaCircle style={{ color: displayDev[34].status[1] === "1" ? "red" : "#cccccc" }} />
                                </td>
                            </tr>
                            <tr>
                                <td>食水缸低水位</td>
                                <td>
                                    <FaCircle style={{ color: displayDev[35].status[0] === "1" ? "red" : "#cccccc" }} />
                                </td>
                                </tr>
                            </td>
                            <td>
                                <tr>
                                    <div className="vbbuttonstyle" style={{ fontSize: "24px", color: "#202020", backgroundColor: "#ffa500", zIndex: 10, position: "relative" }} onClick={() => handleVBClick(81,82)}>
                                        #3號泵震動紀錄
                                    </div>
                                </tr>
                            </td>
                        </table>
                    </td>
                </tr>
            </div>
        );
    }


    function DList() {
        return (
            <div>
                <tr>
                    <td style={{ verticalAlign: "top" }}>
                        <table style={{ fontSize: "12px", verticalAlign: "top", marginTop: "8px", width: "1680px" }}>
                            <tbody>
                                <FFreshList />
                            </tbody>
                        </table>
                    </td>
                </tr>
                <tr>
                    <td style={{ verticalAlign: "top" }}>
                        <table style={{ fontSize: "12px", verticalAlign: "top", marginTop: "8px", width: "1680px" }}>
                            <tbody>
                                <FMiddleAndFireList />
                            </tbody>
                        </table>
                    </td>
                </tr>
            </div>
        )
    };

    return (
        <div className="containerstyle">
            <table>
                <td >

                    <div >
                        <table>
                            <tr>
                                {/*<td style={{ verticalAlign: "top", width: "6%", height: "13.4rem" }}>
                                    <div>
                                        <div className="bbuttonstyle" style={{ fontSize: "22px", color: buildingId === 1 ? "#202020" : "#f5f1eb", backgroundColor: buildingId === 1 ? "#BfBfBf" : "#4f4f4f", zIndex: 10, position: "relative" }} onClick={() => handleClick(1)}>
                                            盈輝樓
                                        </div>
                                        <div className="bbuttonstyle" style={{ fontSize: "22px", color: buildingId === 2 ? "#202020" : "#f5f1eb", backgroundColor: buildingId === 2 ? "#BfBfBf" : "#4f4f4f", zIndex: 10, position: "relative" }} onClick={() => handleClick(2)}>
                                            盈昌樓
                                        </div>
                                    </div>
                                </td>*/}
                        
                                <td>
                                    <div>
                                        <table>
                                            <tr>
                                                <DList />


                                            </tr>
                                            {/*
                                            <tr className="row" >
                                                <td className="large-cellstyle" >
                                                    <div style={{ color: "#f7f4ef", backgroundColor: "#676767" }} >水位檢測</div>
                                                    <hr style={{ height: "15px", visibility: "hidden", marginTop: "0px", marginBottom: "0px" }} />
                                                    <div style={{ color: "#f7f4ef", fontSize: "26px", overflow: "hidden", fontWeight: "bold", textAlign: "center" }}>
                                                        <div style={{ paddingLeft: "20px" }}><img src={waterlevel} alt="waterlevel" height="56" /></div>
                                                        <hr style={{ height: "3px", visibility: "hidden", marginTop: "0px", marginBottom: "0px" }} />
                                                        <div className="lgstatusstyle" style={{ display: "flex", justifyContent: "center", alignItems: "center", fontSize: LargeCellText, color: "#f5f0e9", backgroundColor: "#006ec8" }} >
                                                            正常
                                                        </div>
                                                    </div>

                                                </td>
                                                <td className="large-cellstyle" style={{
                                                    animation: "slideIn 0.5s ease-out forwards",
                                                    animationDelay: "0.2s",
                                                    opacity: 0
                                                }}>
                                                    <div style={{ color: "#f7f4ef", backgroundColor: "#676767" }} >水位過高</div>
                                                    <hr style={{ height: "0px", visibility: "hidden", marginBottom: "0px" }} />
                                                    <div style={{ textAlign: "center" }}> <img src={flood} alt="flood" height="56" /> </div>
                                                    <div className="lgstatusstyle" style={{ display: "flex", justifyContent: "center", alignItems: "center", fontSize: LargeCellText, fontWeight: "bold", color: "#f5f0e9", backgroundColor: "#006ec8" }} >
                                                        正常
                                                    </div>
                                                </td>
                                                <td className="large-cellstyle" style={{
                                                    animation: "slideIn 0.5s ease-out forwards",
                                                    animationDelay: "0.3s",
                                                    opacity: 0
                                                }}>
                                                    <div style={{ color: "#f7f4ef", backgroundColor: "#676767" }} >水房狀態</div>
                                                    <hr style={{ height: "2px", visibility: "hidden", marginBottom: "0px" }} />
                                                    <div style={{ textAlign: "center" }}> <img src={pumpoff} alt="pumpoff" height="56" /> </div>
                                                    <div className="lgstatusstyle" style={{ display: "flex", justifyContent: "center", alignItems: "center", fontSize: LargeCellText, fontWeight: "bold", color: "#f5f0e9", backgroundColor: "#006ec8" }} >
                                                        正常
                                                    </div>
                                                </td>
                                            </tr>
                                            */}
                                        </table>
                                    </div>
                                </td>
                                       
                            </tr>
                        </table>
                    </div>
                </td>
            </table>
        </div>
    );

}